module.exports = __webpack_public_path__ + "static/media/ic_service_layout_grid.8dbcb2c6.svg";